export class ApplicantsChartsModel {
    // studentScoreChart: any = {};
    genderPieChart: any = {};
    regionPieChart: any = {};
    appliedScoreChart: any = {};
    deligenceCallChart: any = {};
    assessmentMarksChart: any = {};
    homeVisitChart: any = {};
    interviewPieChart: any = {};
    rejectedChart: any = {};
    documentationChart: any = {};
}